import React from 'react';
import PropTypes from 'prop-types';
import Lang from 'libraries/Lang';

const VacationDurations = (props) => {
    const {
        onChange, id, value, durations,
    } = props;

    const onSelect = (event) => {
        onChange(event.target.value);
    };

    const durationGroups = {
        threeFour: false, sevenEight: false, fiveTen: false, fourteenFifteen: false, elevenSixteen: false, seventeenPlus: false,
    };
    const list = [];
    for (let i = 0; i < durations.length; i += 1) {
        if (!durationGroups.threeFour && (durations[i] === '3' || durations[i] === '4')) {
            durationGroups.threeFour = true;
        }
        if (!durationGroups.fiveTen && (durations[i] === '5' || durations[i] === '6' || durations[i] === '7' || durations[i] === '8' || durations[i] === '9' || durations[i] === '10')) {
            durationGroups.fiveTen = true;
        }
        if (!durationGroups.sevenEight && (durations[i] === '7' || durations[i] === '8')) {
            durationGroups.sevenEight = true;
        }
        if (!durationGroups.elevenSixteen && (durations[i] === '11' || durations[i] === '12' || durations[i] === '13' || durations[i] === '14' || durations[i] === '15' || durations[i] === '16')) {
            durationGroups.elevenSixteen = true;
        }
        if (!durationGroups.fourteenFifteen && (durations[i] === '14' || durations[i] === '15')) {
            durationGroups.fourteenFifteen = true;
        }
        if (!durationGroups.seventeenPlus && (parseInt(durations[i], 10) >= 17)) {
            durationGroups.seventeenPlus = true;
        }

        if (durations[i] !== '') {
            list.push({ value: `${durations[i]}days`, text: `${durations[i]} ${Lang.trans('engine.days')}` });
        } else {
            durationGroups.elevenSixteen = true;
            durationGroups.fourteenFifteen = false;
            durationGroups.fiveTen = true;
            durationGroups.sevenEight = true;
            durationGroups.threeFour = true;
        }
    }

    if (durationGroups.seventeenPlus) {
        list.unshift({ value: '17days,18days,19days,20days,21days,22days', text: `17 ${Lang.trans('engine.to')} 22 ${Lang.trans('engine.days')}` });
    }
    if (durationGroups.elevenSixteen) {
        list.unshift({ value: '11days,12days,13days,14days,15days,16days', text: `11 ${Lang.trans('engine.to')} 16 ${Lang.trans('engine.days')}` });
    }
    if (durationGroups.fourteenFifteen) {
        list.unshift({ value: '14days,15days', text: `14 ${Lang.trans('engine.or')} 15 ${Lang.trans('engine.days')}` });
    }
    if (durationGroups.fiveTen) {
        list.unshift({ value: '5days,6days,7days,8days,9days,10days', text: `5 ${Lang.trans('engine.to')} 10 ${Lang.trans('engine.days')}` });
    }
    if (durationGroups.sevenEight) {
        list.unshift({ value: '7days,8days', text: `7 ${Lang.trans('engine.or')} 8 ${Lang.trans('engine.days')}` });
    }
    if (durationGroups.threeFour) {
        list.unshift({ value: '3days,4days', text: `3 ${Lang.trans('engine.or')} 4 ${Lang.trans('engine.days')}` });
    }

    return (
        <select id={id} className="w-100 select-unstyled" value={value} onChange={onSelect}>
            {list.map((item) => (<option key={`${item.value}-${item.text}`} value={item.value}>{item.text}</option>))}
        </select>
    );
};

VacationDurations.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    durations: PropTypes.string.isRequired,
    id: PropTypes.string,
};

VacationDurations.defaultProps = {
    id: 'vac_durations',
};

export default VacationDurations;
